const countyConfigFlatFeeReducer = (state = [{}], action) => {
  switch (action.type) {
    case 'LANDSHARK_COUNTY_CONFIG_FLAT_FEE':
      return action.results;
    default:
      break;
  }
  return state;
}

export default countyConfigFlatFeeReducer;